import type { NavGroup } from '@/types/portal';
import { imageUrl } from '@/utils/assets';

export const agency = {
  name: 'Twiva Media Group',
  poweredBy: 'Twiva Pay',
  logoInitials: 'TM',
  domain: 'portal.kilicreatives.co.ke',
  markets: ['Kenya', 'Uganda', 'Tanzania', 'DR Congo', 'Ethiopia'],
  baseCurrency: 'KES',
};

export const currentUser = {
  name: 'Peter Kironji',
  email: 'peter.kironji@twiva.com',
  roleName: 'Agency Administrator',
  avatar: imageUrl('staff/staff-amina.webp'),
  approvalsCeiling: 'Unlimited',
};

export const roleTemplates = [
  {
    id: 'admin',
    name: 'Agency Administrator',
    description: 'Owns the licensed instance, branding, wallets and roles.',
    approvalsCeiling: 'Unlimited',
    permissions: [
      'campaigns.view', 'campaigns.manage', 'campaigns.brief', 'campaigns.approve_content', 'campaigns.close',
      'discovery.view', 'discovery.manage', 'discovery.export',
      'creators.view', 'creators.invite', 'creators.contract',
      'invoices.view', 'invoices.manage', 'invoices.approve',
      'payments.view', 'payments.manage', 'payments.approve',
      'payouts.view', 'payouts.manage', 'payouts.approve',
      'wallets.view', 'wallets.manage', 'wallets.fund',
      'staff.view', 'staff.manage',
      'roles.view', 'roles.manage',
      'settings.view', 'settings.manage', 'settings.branding',
      'reports.view', 'reports.export',
      'audit.view',
    ],
  },
  {
    id: 'finance',
    name: 'Finance User',
    description: 'Approves invoices, funds wallets, executes payouts and reconciles.',
    approvalsCeiling: 'KES 2,000,000',
    permissions: [
      'campaigns.view',
      'invoices.view', 'invoices.manage', 'invoices.approve',
      'payments.view', 'payments.manage', 'payments.approve',
      'payouts.view', 'payouts.manage', 'payouts.approve',
      'wallets.view', 'wallets.manage', 'wallets.fund',
      'reports.view', 'reports.export',
      'audit.view',
    ],
  },
  {
    id: 'creator_manager',
    name: 'Creator Manager',
    description: 'Runs campaigns end to end: discovery, invites, contracts, deliverables.',
    approvalsCeiling: 'KES 250,000',
    permissions: [
      'campaigns.view', 'campaigns.manage', 'campaigns.brief', 'campaigns.approve_content',
      'discovery.view', 'discovery.manage', 'discovery.export',
      'creators.view', 'creators.invite', 'creators.contract',
      'invoices.view',
      'reports.view',
    ],
  },
  {
    id: 'viewer',
    name: 'Campaign Viewer',
    description: 'Reads campaign progress and performance. Takes no actions.',
    approvalsCeiling: 'None',
    permissions: ['campaigns.view', 'reports.view'],
  },
  {
    id: 'client',
    name: 'Client User',
    description: 'An agency client with read access scoped to their campaign.',
    approvalsCeiling: 'None',
    permissions: ['campaigns.view', 'reports.view', 'reports.export'],
  },
];

export const navGroups: NavGroup[] = [
  {
    label: 'Menu',
    items: [
      { label: 'Dashboard', to: '/dashboard', icon: 'ri-dashboard-line' },
      { label: 'Campaigns', to: '/campaigns', icon: 'ri-megaphone-line', permission: 'campaigns.view' },
      { label: 'Creator Discovery', to: '/discovery', icon: 'ri-search-eye-line', permission: 'discovery.view' },
      { label: 'Invoices', to: '/invoices', icon: 'ri-file-list-3-line', permission: 'invoices.view' },
      { label: 'Reports', to: '/reports', icon: 'ri-bar-chart-box-line', permission: 'reports.view' },
    ],
  },
  {
    label: 'Payments',
    items: [
      { label: 'Bulk Payments', to: '/payments/bulk', icon: 'ri-stack-line', permission: 'payments.view' },
      { label: 'Single Payment', to: '/payments/send', icon: 'ri-send-plane-line', permission: 'payments.manage' },
      { label: 'Transactions', to: '/payments/transactions', icon: 'ri-exchange-dollar-line', permission: 'payments.view' },
      { label: 'Wallet', to: '/payments/wallets', icon: 'ri-wallet-3-line', permission: 'wallets.view' },
    ],
  },
  {
    label: 'Settings',
    items: [
      { label: 'Roles & Permissions', to: '/settings/roles', icon: 'ri-shield-user-line', permission: 'roles.view' },
      { label: 'Users', to: '/settings/users', icon: 'ri-team-line', permission: 'staff.view' },
      { label: 'Branding', to: '/settings/branding', icon: 'ri-brush-line', permission: 'settings.branding' },
      { label: 'Audit Log', to: '/settings/audit', icon: 'ri-history-line', permission: 'audit.view' },
    ],
  },
];